import React from "react";
import "./closeTournamentBtn.scss";

const CloseTournamentBtn = ({
  onClick,
  style = {},
  className = "",
  disabled = false,
  text,
  icon: IconComponent,
  width,
}) => {
  return (
    <button
      type="button"
      style={{ width, ...style }}
      className={`close-tournament-btn ${className}`}
      onClick={(e) => {
        if (disabled) return;
        onClick?.(e);
      }}
      disabled={disabled}
      aria-disabled={disabled ? "true" : "false"}
    >
      {IconComponent && (
        <span className="close-tournament-btn-icon">
          <IconComponent fillColor="currentColor" strokeColor="currentColor" />
        </span>
      )}
      {text}
    </button>
  );
};

export default CloseTournamentBtn;
